import { render, staticRenderFns } from "./learningMaterials.vue?vue&type=template&id=6da7e28c&scoped=true"
import script from "./learningMaterials.vue?vue&type=script&lang=js"
export * from "./learningMaterials.vue?vue&type=script&lang=js"
import style0 from "./learningMaterials.vue?vue&type=style&index=0&id=6da7e28c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da7e28c",
  null
  
)

export default component.exports